// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import './assets/font/iconfont.css';
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import cookie from 'vue-cookie'
Vue.prototype.$cookie = cookie;
import { popupModal } from '@/components/oneToOne/popupModal'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en-US',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'kn': require('./common/lang/kn.js'),   // 韩文语言包
    'en-US': require('./common/lang/en'),    // 英文语言包
    'ri': require('./common/lang/ri'),    // 日文语言包
    'zhf': require('./common/lang/zhf'),  // 繁体中文语言包
    'zh': require('./common/lang/zh')  // 中文语言包
  }
})
// import VueCookies from 'vue-cookies'
// Vue.use(VueCookies)
Vue.prototype.$popupModal = popupModal
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueQuillEditor)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js